// store/profileStore.ts
import { ProfileState } from "@/types/profile";
import { create } from "zustand";

export const useProfileStore = create<ProfileState>((set: any) => ({
  profile: null,
  setProfile: (data: any) => set({ profile: data }),
}));
